import tempMeeApi from '../../../apis/tempMee';

/**
 * Bulk upsert from a CSV of (id, status) rows. Unlike the single-target edit
 * this path is intentionally unguarded — it bypasses the transition matrix so
 * backfill and Marketing can set any status, including removals.
 *
 * Continues past per-row failures and reports them, so a 200 does not mean
 * every row applied. Content-Type is left to axios, which sets the multipart
 * boundary from the FormData.
 */
export const uploadMembershipsCsv = async (cycleId, file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await tempMeeApi.post(
    `/awards-service-api/admin/cycles/${cycleId}/memberships/csv`,
    formData,
  );

  return response.data;
};
